import { DOCUMENT } from "@angular/common";
import { Component, Inject, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { IframeModal } from "@edp-pages/iframe/iframe.model";
import { ShowIframeModal } from "@edp-store/actions/iframe.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { DeviceDetectorService } from "ngx-device-detector";
import * as PDFJS from "pdfjs-dist";

@Component({
    selector: "edp-modal-iframe",
    templateUrl: "./edp-modal-iframe.component.html",
    styleUrls: ["./edp-modal-iframe.component.scss"],
})
export class EdpModalIframeComponent implements OnInit {
    @Input() params: IframeModal;
    safeUrl: SafeResourceUrl;
    iframeWidth: string;
    slideUp = false;
    isIOS = false;

    @ViewChild("iframe", { static: false }) iframe: ElementRef;

    constructor(
        private sanitizer: DomSanitizer,
        private store: Store<IAppState>,
        @Inject(DOCUMENT) private document: Document,
        private deviceDetector: DeviceDetectorService
    ) {
        try {
            PDFJS.GlobalWorkerOptions.workerSrc = "pdf.worker.js";
        } catch (error) {
            console.log(error);
        }
    }

    ngOnInit(): void {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.params.url);
        this.slideUp = true;
        this.document.body.classList.add("overflow-hidden");
        this.iframeWidth = `${window.innerWidth}px`;
        this.isIOS = this.deviceDetector.device === "iPhone";
    }

    close(): void {
        this.slideUp = false;
        this.document.body.classList.remove("overflow-hidden");
        setTimeout(() => {
            this.store.dispatch(new ShowIframeModal(null));
        }, 500);
    }

    onError(err) {
        console.log("ERROR ON LOAD PDF VIEWER", err);
    }
}
